export default __webpack_public_path__ + "static/media/inital-scratch-card-dark.bc44e22f.gif";